import styled from 'styled-components';
import { colors } from '../colors';

interface modalHeaderProps {
	paddingTop?: string;
	marginTop?: string;
	flexDirectionColumn?: boolean;
}

const ModalHeader = styled.div<modalHeaderProps>`
	background: ${colors.Grey};
	position: relative;
	padding: 25px 25px;
	display: flex;
	justify-content: space-between;
	font-size: 16px;
	line-height: 19px;
	padding-top: ${({ paddingTop }) => paddingTop}!important;
	margin-top: ${({ marginTop }) => marginTop}!important;
	font-family: 'RubikMedium';
	color: ${colors.White};
	border-bottom: 1px solid ${colors.GreyE1};
	${({ flexDirectionColumn }) =>
		flexDirectionColumn &&
		`flex-direction: column;
	`}
`;

export default ModalHeader;
